import axios from 'axios';

const sendCorporateForm = async (companyName, email, phoneno, fullname, noofguests, selectDate, message) => {
    return axios({
        method: 'post',
        url: '/api/send-corporate-mail',
        data: {
            companyName: companyName,
            email: email,
            phoneno: phoneno,
            fullname: fullname,
            noofguests: noofguests,
            selectDate: selectDate,
            message: message,
        },
    });
};

export default sendCorporateForm;